import store from '@/stores'

export default (to, from, next) => {
  if (store.state.scrolled) {
    store.commit('SET_SCROLLED', { scrolled: false })
  }

  next()
}
